var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIconTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "#55ACEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7379 7.90553C17.2665 8.11456 16.7594 8.25594 16.2276 8.31908C16.7706 7.99377 17.1873 7.47905 17.3839 6.86471C16.8759 7.16609 16.3129 7.38473 15.7143 7.50258C15.2346 6.99177 14.5513 6.67255 13.7946 6.67255C12.3428 6.67255 11.1653 7.85004 11.1653 9.30186C11.1653 9.50794 11.1886 9.70854 11.2337 9.90109C9.04854 9.79148 7.11102 8.74478 5.81411 7.15354C5.58783 7.54179 5.45802 7.99377 5.45802 8.47555C5.45802 9.38755 5.92255 10.1927 6.62767 10.6641C6.19687 10.6505 5.79117 10.5323 5.43684 10.3348C5.43665 10.346 5.43665 10.3572 5.43665 10.3682C5.43665 11.6421 6.34335 12.7047 7.54594 12.9461C7.32554 13.0065 7.09278 13.0385 6.85336 13.0385C6.68355 13.0385 6.51904 13.0222 6.35864 12.9916C6.69316 14.0359 7.66398 14.7962 8.81481 14.8175C7.91477 15.5229 6.7812 15.9431 5.549 15.9431C5.33723 15.9431 5.12742 15.9307 4.92212 15.9062C6.0851 16.6525 7.4675 17.0876 8.95226 17.0876C13.7885 17.0876 16.4333 13.0812 16.4333 9.60638C16.4333 9.49245 16.4308 9.37892 16.4257 9.26636C16.9398 8.89576 17.3855 8.43281 17.7379 7.90553Z",
    fill: "#F1F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconTwitter);
export default __webpack_public_path__ + "static/media/social-icon-twitter.9280206a.svg";
export { ForwardRef as ReactComponent };